import React from 'react';
import '@questlabs/react-sdk/dist/style.css';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Translations from './components/Translations';
import SocialProof from './components/SocialProof';
import FAQ from './components/FAQ';
import Urgency from './components/Urgency';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-brand-white selection:bg-brand-yellow selection:text-brand-dark">
      <Hero />
      <Problem />
      <Solution />
      <Translations />
      <SocialProof />
      <FAQ />
      <Urgency />
      <Footer />
    </div>
  );
}

export default App;